import React from "react";
import { inject, observer } from "mobx-react";

const MilestoneList = (props) => {
  const { goal, goalVal, milestones, percent } = props.overlayStore;

  const formatNumber = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value
        .replace(/\.00$/, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return value;
  };

  const addZeroes = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value.toFixed(2).replace(/\.00$/, "");
    }
    return value;
  };

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const textColor = urlParams.get("textColor");

  return (
    <div className="milestones">
      {milestones.map((milestone) => (
        <div
          key={milestone.id}
          className={`
              ${
                Math.round(
                  100 * (parseFloat(milestone.amount.value) / parseFloat(goal))
                ) > percent
                  ? "milestones__text higher"
                  : "milestones__text lower"
              }
            `}
        >
          {/* <div className="m_next">Next Milestone:</div>  */}

          <div className={`m_info ${textColor}`}>
            <span>
              <strong>${Number(milestone.amount.value)}</strong> -{" "}
              {milestone.name}
            </span>
          </div>
        </div>
      ))}
      <div className="milestones__text higher">
        <div className={`m_info ${textColor}`}>
          <span>
            <strong>${goalVal}</strong> - Reach our goal!
          </span>
        </div>
      </div>
    </div>
  );
};

export default inject("overlayStore")(observer(MilestoneList));

// {donation.comment ? `"${donation.comment}"` : ""}
// progress = percent > 100 ? 100 : percent;
